/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CityDto } from './CityDto';
import {
    CityDtoFromJSON,
    CityDtoFromJSONTyped,
    CityDtoToJSON,
    CityDtoToJSONTyped,
} from './CityDto';

/**
 * 
 * @export
 * @interface CitiesResponseDto
 */
export interface CitiesResponseDto {
    /**
     * List of cities
     * @type {Array<CityDto>}
     * @memberof CitiesResponseDto
     */
    data: Array<CityDto>;
    /**
     * Total number of cities
     * @type {number}
     * @memberof CitiesResponseDto
     */
    total: number;
    /**
     * Country code
     * @type {string}
     * @memberof CitiesResponseDto
     */
    countryCode: string;
    /**
     * State code
     * @type {string}
     * @memberof CitiesResponseDto
     */
    stateCode: string;
}

/**
 * Check if a given object implements the CitiesResponseDto interface.
 */
export function instanceOfCitiesResponseDto(value: object): value is CitiesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('stateCode' in value) || value['stateCode'] === undefined) return false;
    return true;
}

export function CitiesResponseDtoFromJSON(json: any): CitiesResponseDto {
    return CitiesResponseDtoFromJSONTyped(json, false);
}

export function CitiesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CitiesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CityDtoFromJSON)),
        'total': json['total'],
        'countryCode': json['countryCode'],
        'stateCode': json['stateCode'],
    };
}

export function CitiesResponseDtoToJSON(json: any): CitiesResponseDto {
    return CitiesResponseDtoToJSONTyped(json, false);
}

export function CitiesResponseDtoToJSONTyped(value?: CitiesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(CityDtoToJSON)),
        'total': value['total'],
        'countryCode': value['countryCode'],
        'stateCode': value['stateCode'],
    };
}

